export default "__VITE_ASSET__642941b4__"